import { render, staticRenderFns } from "./RoleEdit.vue?vue&type=template&id=0a480a92&scoped=true"
import script from "./RoleEdit.vue?vue&type=script&lang=js"
export * from "./RoleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a480a92",
  null
  
)

export default component.exports